import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#fa4d56","line-height":"22px","font-style":"normal","text-transform":"none","margin-bottom":"24px"} }, " 入金账户 （此账户只用于充值使用） ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"background":"#ffefe5","box-sizing":"border-box","padding":"8px","font-size":"14px","color":"var(--xrk-color-primary)","line-height":"22px","font-style":"normal","text-transform":"none"} }, " 温馨提示：请通过网银将充值金额汇入对应账户，请切记使用对公账户打款方式。具体到账时间以收款银行到账时间为准。 ", -1)
const _hoisted_3 = { style: {"display":"flex","align-items":"center","gap":"24px","margin":"18px 0 10px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","color":"#121619","text-align":"left","font-style":"normal","text-transform":"none"} }, " 近3笔充值记录 ", -1)

import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTable,
  BaseTableProps,
  useTableColumn,
  BaseButton,
  useCreateModal,
  BaseForm,
  BaseTextContent,
  BaseFormItem,
  BaseInput
} from 'xrk-components';
import AccountMainRechargeRecordDialog from './account-main-recharge-record-dialog.vue';
import { rechargeInfo } from '../data-source/apis';
import { RechargeInfoData } from '../data-source/types';
import { PayPassagewayCode } from '@cTypes/bank';
import { formatter, http } from '@/utils';
import appStore from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-main-recharge-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    payPassagewayCode: { default: 'fyBank' }
  },
  setup(__props: any) {

const props = __props;

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const rechargeData = ref<RechargeInfoData>({
  companyName: '',
  bfBankNumber: '',
  openBankName: '',
  openBankNode: '',
  fySubBranchName: '',
  rechargeList: []
});

const onMore = () => {
  useCreateModal(AccountMainRechargeRecordDialog);
};

onMounted(async () => {
  const { data } = await rechargeInfo({
    payPassagewayCode: props.payPassagewayCode,
    functionCode: userInfo.value.functionCode,
    departmentId: userInfo.value.depId
  });
  rechargeData.value = data;
});

const columns: BaseTableProps['columns'] = [
  useTableColumn({
    type: 'index',
    label: '序号',
    width: '80px'
  }),
  useTableColumn({
    label: '打款账户名称',
    prop: 'bankAccName'
  }),
  useTableColumn({
    label: '打款账户号',
    prop: 'bfBankNumber'
  }),
  useTableColumn({
    label: '金额',
    prop: 'amount',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
  }),
  useTableColumn({
    label: '流水号',
    prop: 'outTradeNo'
  }),
  useTableColumn({
    label: '日期',
    prop: 'finishPayDt',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  }),
  useTableColumn({
    label: '操作',
    fixed: 'right',
    render: ({ row }) => {
      const { bankPayVoucherUrl } = row;
      return (
        <>
          {bankPayVoucherUrl && (
            <div>
              <BaseButton
                type="text"
                click={async () => {
                  await http.download({
                    url: bankPayVoucherUrl,
                    method: 'GET'
                  });
                }}
              >
                下载回执单
              </BaseButton>
            </div>
          )}
        </>
      );
    }
  })
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "880px",
    title: "对公账户充值"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.remove()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(BaseForm), {
            style: {"grid-template-columns":"repeat(2, 1fr)"},
            "label-position": "top",
            model: _unref(rechargeInfo)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "户名",
                prop: "companyName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    disabled: "",
                    modelValue: rechargeData.value.companyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rechargeData.value.companyName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "账号",
                prop: "bfBankNumber"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "text",
                    style: {"width":"100%"},
                    disabled: "",
                    modelValue: rechargeData.value.bfBankNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rechargeData.value.bfBankNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "开户行",
                prop: "openBankName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "text",
                    style: {"width":"100%"},
                    disabled: "",
                    modelValue: rechargeData.value.openBankName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rechargeData.value.openBankName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "支行名称",
                prop: "fySubBranchName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "text",
                    style: {"width":"100%"},
                    disabled: "",
                    modelValue: rechargeData.value.fySubBranchName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rechargeData.value.fySubBranchName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "联行号",
                prop: "openBankNode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "text",
                    style: {"width":"100%"},
                    disabled: "",
                    modelValue: rechargeData.value.openBankNode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rechargeData.value.openBankNode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(BaseButton), {
                type: "text",
                onClick: onMore
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看更多")
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(BaseTable), {
              data: rechargeData.value.rechargeList,
              columns: columns
            }, null, 8, ["data"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})